import React from 'react';
import {
  ActionButton,
  Button,
  ButtonGroup,
  Content,
  Dialog,
  DialogTrigger,
  Divider,
  Heading,
  Link,
  Text
} from '@adobe/react-spectrum';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

const RegularText = styled.span`
  text-align: left;
  font-size: 16px;
  color: #2c2c2c;
  display: block;
  margin: 0 0 12px 0;
`;

const SecurityEnforcementDialog = ({ isOpen, onClose }) => {
  const history = useHistory();

  const viewRecommendations = () => {
    onClose();
    // 'securityEnforcement' matches SecurityEnforcement::VARIABLE on the backend (issue_code).
    history.push('/commerce/tab/recommendations', { selectIssueCode: 'securityEnforcement' });
  };

  return (
    <DialogTrigger isOpen={isOpen} onOpenChange={open => { if (!open) { onClose(); } }}>
      <ActionButton isHidden="true" id="securityEnforcementDialogButton">Security Enforcement</ActionButton>
      <Dialog size="M">
        <Heading>Security Enforcement Policy Deadline</Heading>
        <Divider />
        <Content>
          <Text>
            <RegularText>
              Adobe's Security Enforcement Policy sets hard deadlines by which the Adobe Commerce
              version and/or its software dependencies must be upgraded. One or more components on
              this project are within the notification window of (or past) their enforcement
              deadline.
            </RegularText>
            <RegularText>
              After the deadline, Adobe may suspend traffic to the affected infrastructure —
              taking the storefront offline — and, if non-compliance continues, decommission the
              environment, permanently deleting its data and assets.
            </RegularText>
            <RegularText>
              See the{' '}
              <Link>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://experienceleague.adobe.com/en/docs/commerce-operations/release/planning/security-enforcement-policy"
                >
                  Adobe Commerce Security Enforcement Policy
                </a>
              </Link>{' '}
              for details.
            </RegularText>
          </Text>
        </Content>
        <ButtonGroup>
          <Button variant="secondary" onPress={onClose} data-ui-id="security-enforcement-dialog-close">
            Close
          </Button>
          <Button variant="cta" onPress={viewRecommendations} data-ui-id="security-enforcement-dialog-view-recommendations">
            View Recommendations
          </Button>
        </ButtonGroup>
      </Dialog>
    </DialogTrigger>
  );
};

export default SecurityEnforcementDialog;
